import { Navigate, useParams } from 'react-router-dom';

/**
 * Redirects the old standalone team route
 * (`/public/:leagueId/:seasonId/team/:teamId`) to the in-page ESPN team detail
 * view on the public league page (`/public/:leagueId/:seasonId?team=:teamId`).
 * This keeps deep links working while serving a single, sport-aware team design.
 */
export default function PublicTeamRedirect() {
  const { leagueId, seasonId, teamId } = useParams<{ leagueId: string; seasonId: string; teamId: string }>();
  if (!leagueId || !seasonId || !teamId) {
    return <Navigate to="/" replace />;
  }
  return <Navigate to={`/public/${leagueId}/${seasonId}?team=${teamId}`} replace />;
}
